// extracted by mini-css-extract-plugin
export default {"form_control":"Select_form_control__rN6DC","perguntaBonus":"Select_perguntaBonus__5QEio"};